module.exports = __webpack_public_path__ + "static/media/oca.eaeceb04.svg";